<section class="places-list">
    @if (!isFetching) {
        <ul class="places-list__list">
            @if (activePlaces.length) {
                @for (place of activePlaces; track place.name) {
                    <li class="places-list__list__item">
                        <div class="places-list__item"
                             [class.places-list__item--cursor]="isAttractions && place.type === eAttractionTypes.INSIDE_CITY"
                             [style.background-image]="'url(' + place.imageUrl + ')'"
                             (click)="handleShowAttraction($event, place)">
                            @if (!isAttractions || (isAttractions && place.type !== eAttractionTypes.INSIDE_CITY)) {
                                <a [routerLink]="place.link">
                                    <div class="places-list__item__name">{{ place.name }}</div>
                                </a>
                            }
                            @if (isAttractions && place.type === eAttractionTypes.INSIDE_CITY) {
                                <div class="places-list__item__name"
                                     (click)="handleShowAttraction($event, place)">
                                    {{ place.name }}
                                </div>
                            }
                        </div>
                        @if (breakpointConfig.isMobile()) {
                            <div class="places-list__country-description-name"
                                 (click)="handleShowAttraction($event, place)">
                                <h3 class="city-name">{{ place.name }}</h3>
                                @if (place?.description; as placeDescription) {
                                    <p class="city-description" [innerHTML]="placeDescription | safeHtml"></p>
                                    <p class="city-description read-more">Read more</p>
                                }
                            </div>
                        }
                    </li>
                }
            } @else {
                <li class="places-list__item places-list__item--empty">
                    @if (isAttractions) {
                        {{ 'LOCATION_LIST.ATTRACTION_NOT_FOUND' | translate }}
                    } @else {
                        {{ 'LOCATION_LIST.LIST_EMPTY' | translate }}
                    }
                </li>
            }
        </ul>

        @if (showMorePlacesCount > 0) {
            <div class="places-list__button">
                <a class="orangeLink" (click)="showMore()">
                    {{ 'LOCATION_LIST.SHOW_MORE' | translate }}
                </a>
            </div>
        }
    } @else {
        <ul class="places-list__list">
            @for (item of fetchingItems; track $index) {
                <li class="places-list__list__item">
                    <div class="places-list__item">
                        <ngx-skeleton-loader [theme]="{height: 155 + 'px', margin: 0}"></ngx-skeleton-loader>
                    </div>
                </li>
            }
        </ul>
    }
</section>
